"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var responsiveObserve_1 = tslib_1.__importDefault(require("./responsiveObserve"));
function useBreakpoint() {
    var _a = tslib_1.__read((0, react_1.useState)({}), 2), screens = _a[0], setScreens = _a[1];
    (0, react_1.useEffect)(function () {
        var token = responsiveObserve_1.default.subscribe(function (supportScreens) {
            setScreens(supportScreens);
        });
        return function () { return responsiveObserve_1.default.unsubscribe(token); };
    }, []);
    return screens;
}
exports.default = useBreakpoint;
//# sourceMappingURL=useBreakpoint.js.map